import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login';
import DiseaseMainPage from "@/views/DiseaseMainPage";
import DiseaseKeShiPage from "@/views/DiseaseKeShiPage";
import DiseaseDetailPage from "@/views/DiseaseDetailPage";
import JingLuoDetailPage from "@/views/JingLuoDetailPage";
import Setting from "@/views/Setting";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login
  },
  {
    path: '/mainPage',
    name: 'MainPage',
    component: Home,
    meta: {
      // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      keepAlive: true, //此组件不需要被缓存
    },
  },
  {
    path: '/diseaseMainPage',
    name: 'DiseaseMainPage',
    component: DiseaseMainPage
  },
  {
    path: '/diseaseKeShiPage',
    name: 'DiseaseKeShiPage',
    component: DiseaseKeShiPage
  },
  {
    path: '/diseaseDetailPage',
    name: 'DiseaseDetailPage',
    component: DiseaseDetailPage
  },
  {
    path: '/jingLuoDetailPage',
    name: 'JingLuoDetailPage',
    component: JingLuoDetailPage
  },
  {
    path: '/settingPage',
    // path: '/',
    name: 'SettingPage',
    component: Setting
  },
  {
    path: '/1',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
